import request from "@utils/request";

/**
 * 初始化枚举
 * @returns {*}
 */
export function initEnumDatas(){
  return request.get("/sys/enum/initEnumDatas");
}

/**
 * 登录逻辑
 * @param data
 * @returns {*}
 */
export function login(data){
  return request.post("/login", data);
}

/**
 * 根据用户账号获取用户ID
 */
/*export function findSysUserIdByAccountLogin(accountLogin){
  return request.get("/sys/user/getSysUserIdByAccountLogin?accountLogin="+accountLogin);
}*/

/**
 * 获取列表数据,分页查询
 * @param url
 * @param data
 * @returns {*}
 */
export function getTableData(url,data) {
  return request.post(url, data);
}

/**
 * 查询所有数据，不分页
 * @param serviceUrl
 * @param data
 * @returns {*}
 */
export function getAllTableData(serviceUrl,data) {
  return request.post(serviceUrl+"/getAllTableData", data);
}

/**
 * 修改页面
 * @param serviceUrl
 * @param param
 * @returns {*}
 */
export function edit(serviceUrl,param){
  return request.get(serviceUrl+"/edit?"+param);
}

/**
 * 普通表单的保存
 * @param serviceUrl
 * @param param
 * @returns {*}
 */
export function save(serviceUrl,param){
  return request.post(serviceUrl+"/save",param);
}

/**
 * 树表删除节点
 * @param url
 * @returns {*}
 */
export function deleted(serviceUrl,idName,ids){
  return request.get(serviceUrl+"/delete?"+idName+"s="+ids);
}

/**
 * 树节点保存
 * @param url
 * @param data
 * @returns {*}
 */
export function saveNode(url,data){
  return request.post(url,data);
}

/**
 * wrapper-tree.vue  selectTree
 * 查询树表数据，目前可接受参数是parentId,可以拓展一下，前端传递query_like_nodeCode或者query_EQ_parentId
 * @param url
 * @param data
 * @returns {*}
 */
export function getTreeData(serviceUrl,data) {
  return request.post(serviceUrl+"/getTreeData", data);
}

/**
 * wrapper-tree.vue,右键点击
 * 根据当前点击节点的上级父节点,不适合从funcOperMap里边取，因为这个树的数据是随时增删改查的，需要知道最新数据
 * @param url
 * @param data
 * @returns {*}
 */
export function getCurrentNodeParentId(serviceUrl,id) {
  return request.get(serviceUrl+"/getCurrentNodeParentId?id="+id);
}

/**
 * 点击树节点，同级树节点收起，当前节点展开
 * @param serviceUrl
 * @param id
 * @returns {*}
 */
export function getSiblingIds(serviceUrl,id) {
  return request.get(serviceUrl+"/getSiblingIds?id="+id);
}

/**
 * 点击树节点，获取父节点ids
 * @param serviceUrl
 * @param id
 * @returns {*}
 */
export function getTreeParentIds(serviceUrl,id) {
  return request.get(serviceUrl+"/getTreeParentIds?id="+id);
}

/**
 * 用于功能修改页面，功能类型为操作时，显示的操作数据
 * @returns {*}
 */
export function findAllFuncOpers(){
  return request.get("/sys/func/oper/findAllFuncOpers");
}

/**
 * 获取用户角色,
 * @param sysUserId
 * @returns {*}
 */
export function getUserRole(sysUserId){
  return request.get("/sys/user/getUserRole?sysUserId="+sysUserId);
}

/**
 * 保存用户角色
 * @param sysUserId
 * @returns {*}
 */
export function saveUserRole(data){
  return request.post("/sys/user/saveUserRole",data);
}

/**
 * 获取角色功能ids
 * @param data
 * @returns {*}
 */
export function getRoleFunc(id){
  return request.get("/sys/role/getRoleFuncIds?id="+id);
}

/**
 * 保存角色功能
 * @param data
 * @returns {*}
 */
export function saveRoleFunc(data){
  return request.post("/sys/role/saveRoleFunc",data);
}

/**
 * 根据附件id删除
 * @param id
 * @returns {*}
 */
export function deleteFileById(id){
    return request.get("/sys/file/deleteFile?fileId="+id);
}

/**
 * 批量清理所有异常数据
 * @returns {*}
 */
export function batchClear(){
  return request.get("/sys/exception/batchClear");
}